import {defaultBreadcrumbs, ScreenProp} from 'src/app/models'

export const OrganizationScreen: Record<string, ScreenProp> = {
  ORGANIZATION: {
    PATH: '/administration/setup-organization',
    TITLE: 'Organisasi',
    TITLE_ALT: 'Organization',
    breadcrumbs: defaultBreadcrumbs,
  },
  ORGANIZATION_ADD: {
    PATH: '/administration/setup-organization/add',
    TITLE: 'Buat Organisasi',
    TITLE_ALT: 'Buat Organisasi',
    breadcrumbs: defaultBreadcrumbs,
  },
  ORGANIZATION_EDIT: {
    PATH: '/administration/setup-organization/edit/:id',
    TITLE: 'Edit Organisasi',
    TITLE_ALT: 'Edit Organisasi',
    breadcrumbs: defaultBreadcrumbs,
  },
  ORGANIZATION_DETAIL: {
    PATH: '/administration/setup-organization/detail/:id',
    TITLE: 'Detail Organisasi',
    TITLE_ALT: 'Detail Organisasi',
    breadcrumbs: defaultBreadcrumbs,
  },
}
